import React, { useState } from 'react'
import { useAddNewSubCategoryMutation } from '../../api/subCategoryApiSlice'
import SubCategoryAddPresentation from '../../presentation/subcategory.add.presentation/subcategory.add.presentation'
import { type SubCategoryAddContainerProp } from '../../types/types'
const SubCategoryAddContainer: React.FC<SubCategoryAddContainerProp> = ({
  categoryId
}) => {
  const [addNewSubCategory] =
    useAddNewSubCategoryMutation();

  const [title, setTitle] = useState<string>('')

  const titleChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value)
  }

  const onSubCategorySave = async () => {
    try {
      await addNewSubCategory({
        title,
        category: { _id: categoryId }
      }).unwrap()
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <SubCategoryAddPresentation
      title={title}
      titleChangeHandler={titleChangeHandler}
      onSubCategorySave={onSubCategorySave}
    />
  )
}

export default SubCategoryAddContainer
